import flatten from 'lodash-es/flatten';
import get from 'lodash-es/get';
import has from 'lodash-es/has';
import uniq from 'lodash-es/uniq';
import request from 'superagent';

import { isObjectOfType } from '../objects';
import { preloadFromSlides, preloadFromObject } from '../preload';
import { findImagesInObjectsByPublicId } from '../images';
import { UPLOAD_STATE_UPLOADED } from '../upload/constants';

const forEachObjectOfType = (objects, callback, ...types) => {
  if (!objects) {
    return;
  }
  objects.forEach(object => {
    if (isObjectOfType(object, ...types)) {
      callback(object);
    }
    if (isObjectOfType(object, 'group')) {
      forEachObjectOfType(object.objects, callback, ...types);
    }
  });
};

export const preloadCanvasImage = object => (dispatch, getState) => {
  const { appInstanceId } = getState().collaborationReducer;
  const { images } = getState().imagesReducer;
  const publicId = get(object, 'ludus.publicId');
  const uploadState = get(images, [publicId, 'uploadState']);
  // If the image is currently being uploaded, skip preload
  if (uploadState && uploadState !== UPLOAD_STATE_UPLOADED) {
    return;
  }

  const imageObject = {
    ...object,
    ludus: {
      ...object.ludus,
      uploadState: undefined,
    },
  };

  dispatch({ type: 'IMAGE_PRELOADED', object: imageObject });
  preloadFromObject(imageObject, appInstanceId);
};

export const preloadUploadedImage = publicId => (dispatch, getState) => {
  const slides = getState().contentReducer.presentation.slides;

  const images = flatten(
    Object.values(slides)
      .map(slide =>
        findImagesInObjectsByPublicId(slide.content.objects, publicId),
      )
      .filter(slideImages => slideImages.length > 0),
  );

  images.forEach(image => dispatch(preloadCanvasImage(image)));
};

/**
 * Preload images for the provided slides and symbols
 *
 * @param slides
 * @param symbols
 */
export const preloadSlideImages = (slides, symbols) => (dispatch, getState) =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async resolve => {
    const { appInstanceId } = getState().appReducer;
    preloadFromSlides(slides, appInstanceId);

    const lottieUrls = [];
    slides.forEach(slide => {
      forEachObjectOfType(
        Object.values(slide.content.objects || {}),
        object => {
          if (object.ludus.url !== null && object.ludus.url !== undefined) {
            lottieUrls.push(object.ludus.url);
          }
        },
        'lottie',
      );
    });
    symbols.forEach(symbol => {
      const symbolContent = JSON.parse(symbol.content);
      if (has(symbolContent, 'objects')) {
        forEachObjectOfType(
          symbolContent.objects,
          object => {
            if (object.ludus.url !== null && object.ludus.url !== undefined) {
              lottieUrls.push(object.ludus.url);
            }
          },
          'lottie',
        );
      }
    });

    const downloadPromises = uniq(lottieUrls).map(async lottieUrl => {
      const response = await request.get(lottieUrl);
      if (response.ok) {
        return {
          url: lottieUrl,
          data: JSON.stringify(response.body),
        };
      }

      return null;
    });
    const downloadResults = await Promise.all(downloadPromises);

    dispatch({ type: 'PRELOAD_LOTTIE', preLoaded: downloadResults });

    resolve();
  });
